import { ArrowUpRight } from "lucide-react";
import { MaskedLine, FadeUp } from "./Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="mx-auto max-w-[1400px] px-6 py-12 lg:px-12 lg:py-28">
      <div className="mb-6 grid grid-cols-1 gap-6 lg:mb-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <FadeUp>
            <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.35em] text-taupe">
              <span className="inline-block h-2 w-2 bg-clay" />
              What we do
            </p>
          </FadeUp>
        </div>
        <h2 className="font-serif text-4xl leading-[1.08] tracking-tighter sm:text-5xl lg:col-span-8 lg:text-6xl">
          <MaskedLine>Ten crafts,</MaskedLine>
          <MaskedLine delay={0.12}>
            <em className="text-terra">one roof.</em>
          </MaskedLine>
        </h2>
      </div>
      <div>
        {SERVICES.map((s, i) => (
          <FadeUp key={s.n} delay={i * 0.04} y={20}>
            <div
              data-testid={`service-row-${s.n}`}
              className="group grid cursor-default grid-cols-12 items-center gap-3 border-t border-line py-4 transition-[background-color,padding] duration-500 last:border-b hover:bg-sand hover:pl-4 md:gap-4 md:py-7"
            >
              <span className="col-span-2 font-serif text-sm text-terra md:col-span-1 md:text-base">
                {s.n}
              </span>
              <h3 className="col-span-9 font-serif text-xl tracking-tight transition-transform duration-500 group-hover:translate-x-2 sm:text-3xl md:col-span-5 lg:text-4xl">
                {s.title}
              </h3>
              <p className="col-span-9 col-start-3 text-sm text-taupe md:col-span-4 md:col-start-auto">
                {s.tag}
              </p>
              <span className="col-span-1 hidden justify-self-end text-taupe transition-all duration-500 group-hover:text-ink md:block">
                <ArrowUpRight size={22} className="transition-transform duration-500 group-hover:rotate-45" />
              </span>
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
